import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { WIDGET_CONFIG_PATH } from "utils/constants/paths";

const WidgetConfig = Loadable(React.lazy(() => import("./View")));

export const WidgetConfigRoute: IRouteItem = {
  path: WIDGET_CONFIG_PATH,
  element: React.createElement(WidgetConfig),
  accessKeys: ["Support", "ContentCreator", "Analyst", "SystemUserManager"],
  name: "Widget",
  iconName: "Element4",
};
